import { PaxFormControlBase } from './pax-form-control-base';
import { IMyOptions } from 'mydatepicker';

export class PaxFormControlDatepicker extends PaxFormControlBase<string> {
  controlType = 'datepicker';
  settings: IMyOptions;

  constructor(options: {} = {}) {
    super(options);
    this.settings =  options['settings'] || [];
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/shared/pax-form-control/pax-form-control-datepicker.ts